import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnInit {

  @Input() loading: boolean | undefined;
  @Input() style: any;
  @Input() label = 'Loading...';
  @Input() small = false;

  constructor() { }

  ngOnInit() {
  }

}
